<template>
  <section class="add-a-review" :class="{ desktop: $isDesktop }">
    <booking-campsite-details
      v-if="campsite"
      :address="campsite.fullAddress2"
      :campsite-name="campsite.name"
      :pitch-name="booking?.pitchtype?.name"
      :photo="reviewPhoto"
      :arrive="booking?.arrive"
      :depart="booking?.depart"
    />
    <add-campsite-review-form
      v-if="campsite"
      :campsite-name="campsite.name"
      :campsite-slug="campsite.slug"
      :token="token"
      :booking="booking"
      :errors="errors"
      :states="states"
      :initial-overall-rating="initialOverallRating"
      @submit="$emit('submit', $event)"
    />
  </section>
</template>
<script lang="ts">
import type { CampsiteDetails } from '~/apps/campsite-details/types'
import AuthMixin from '~/mixins/AuthMixin'
import { Component, Prop, toNative, Vue } from '~/utility/pu-class-decorator'
import { AddReviewStateMachineInterpreter } from '../machine'

@Component({
  mixins: [AuthMixin],
})
class AddAReview extends Vue {
  @Prop()
  campsite: CampsiteDetails

  @Prop()
  booking: AddReviewStateMachineInterpreter['state']['context']['booking']

  @Prop()
  token: string

  @Prop()
  errors: Record<string, string>

  @Prop()
  states: string[]

  @Prop()
  initialOverallRating?: number

  get reviewPhoto() {
    if (this.booking && this.booking.primaryPhoto) {
      return this.booking.primaryPhoto
    } else if (this.booking) {
      return this.campsite.primaryPhoto
    }
  }

  get ratingObject() {
    if (!this.campsite.rating) {
      return undefined
    }
    return {
      rate: this.campsite.rating * 2,
      votes: this.campsite.rateCount,
    }
  }
}

export default toNative(AddAReview)
</script>

<style scoped>
section {
  padding: 1em 0 3em 0;
}

.add-a-review :deep(.overallrate label),
.add-a-review :deep(label.asblock > span),
.add-a-review :deep(.ratings-section > label),
.add-a-review :deep(.base-radio-options > label),
.add-a-review :deep(.asterisk),
.add-a-review :deep(.field-label) {
  font-size: 16px;
}

.add-a-review :deep(.asterisk) {
  margin-left: 0.25em;
}

.add-a-review :deep(label span.label-help) {
  font-size: 14.25px;
}

.add-a-review :deep(.cs-details) {
  padding-bottom: 0;
}

/* desktop & tablet */
.add-a-review.desktop {
  margin: auto;
  max-width: var(--legacy-page-width-max);
  width: 100%;
}

.add-a-review.desktop :deep(.top-line) {
  background-color: transparent;
}

.add-a-review.desktop :deep(.overallrate label),
.add-a-review.desktop :deep(label.asblock > span:not(.label-help)),
.add-a-review.desktop :deep(.ratings-section > label),
.add-a-review.desktop :deep(.field-label) {
  font-size: 19px;
}

.add-a-review.desktop :deep(form .base-radio-options + .input-error-msg),
.add-a-review.desktop :deep(form .ratings-section .input-error-msg) {
  width: auto;
  display: inline-block;
}

.add-a-review.desktop :deep(.overallrate) {
  margin: 1em 0 2em;
}
</style>
